import { requestV1 } from './base'
import { Top, FirstView } from './response_types'

export const getTop = async () => {
  return await requestV1<Top>('get', '/top')
}

export const getFirstView = async () => {
  return await requestV1<FirstView>('get', '/top/first_view')
}
